import View from '../core/view/View';
import Model from '../core/model/Model';
import { node } from '../core/node/Node';

/**
 * A helper view that simple renders html
 */
export default class Show extends View<ShowModel> {

	private placeholder:Comment;

	constructor( ) {
		super( { template:'', data:new ShowModel( { if:true } ) } );

		this.placeholder = document.createComment('');

		this.template.dataFactory = () => {
			return this.parent.data;
		}
	}

	init() {
		this.checkVisibility();

		this.data.change.filter( c => c.name == 'if' ).subscribe( this.onModelChange.bind( this ) );
	}

	onModelChange() {
		this.checkVisibility();
	}

	checkVisibility() {
		if( this.data.if && this.placeholder.parentNode ) node( this.placeholder ).replace( this.node );
		if( !this.data.if && this.node.parentNode ) node( this.node ).replace( this.placeholder );
	}
}

class ShowModel extends Model {
	if:boolean;
}
